import * as React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setQuoteResponse } from '../../redux/actions';
import { setTravelDetails } from '../../redux/actions/travelDetailsActions';
// import { debounce } from 'lodash';
import DatePicker from "react-datepicker";
// import { format } from 'date-fns';
import { updateBookingPrice } from '../../redux/actions/bookingActions'; // Import the booking action
import { setCreateBookingResponse } from '../../redux/actions/createBookingActions';
import PromoCodeInput from '../PromoCodeInput';
import InputAdornment from '@mui/material/InputAdornment'; // Import InputAdornment
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import ClearIcon from '@mui/icons-material/Clear';
// import { pushSearchEvent } from '../../gtm'; // Adjust the path to match the location of your utility file
import WarningIcon from '@mui/icons-material/Warning'; // Import the Warning icon from Material-UI
import { setSelectedDestination } from '../../redux/actions/selectedDestinationActions'; // Adjust the path
import { setSelectedDropOff } from '../../redux/actions/selectedDropOffActions';
// import { TimePicker } from '@mui/x-date-pickers/TimePicker';
// import { DesktopTimePicker } from '@mui/x-date-pickers/DesktopTimePicker';
import { addDays } from 'date-fns';
import useMediaQuery from '@mui/material/useMediaQuery';
import Modal from '@mui/material/Modal';
import {setPromoCode, setPromo, setCodeApplied} from "../../redux/actions/setPromoCode";

import {
  Typography,
  TextField,
  Button,
  Popover,
  MenuItem,
  ListItemIcon,
  DialogTitle,
  DialogContent,
  Paper,
  CircularProgress,
  IconButton,
} from '@mui/material';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import BoyIcon from '@mui/icons-material/Boy';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import FlightIcon from '@mui/icons-material/Flight';
import BusinessIcon from '@mui/icons-material/Business';
import TrainIcon from '@mui/icons-material/Train';
import GolfCourseIcon from '@mui/icons-material/GolfCourse';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import Link from '@mui/material/Link';

import { TimePicker } from 'antd';
import {withStyles} from "@mui/styles";

const styles = (theme) => ({
  centerAlignXs: {
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      justifyContent: 'center',
    },
  },
  root: {
    flexGrow: 1,
    backgroundColor: '#FCFDFD',
  },
  title: {
    textAlign: 'center',
    color: '#444',
    font: '18px arial,serif',
    fontFamily: 'Nexa,sans-serif',
    fontWeight: 'bold',
  },
  title2: {
    textAlign: 'center',
    fontSize: '2rem',
    fontWeight: '700',
    color: '#333',
    fontFamily: 'Nexa,sans-serif',
    lineHeight: '1.1',
  },
  title3: {
    fontSize: '24px',
    fontFamily: 'Nexa,sans-serif',
    color: '#265886',
    lineHeight: '1.5',
    fontWeight: '700',
  },
  subtitle: {
    textAlign: 'left',
    font: '14px arial,serif',
    fontFamily: 'Nexa,sans-serif',
    color: '#444',
    marginTop: '10px',
  },
  subtitle1: {
    textAlign: 'center',
    fontSize: '1em',
    fontFamily: 'Nexa,sans-serif',
    color: '#444',
    fontWeight: '700',
  },
  info: {
    fontSize: '12px',
    color: '#444',
    fontFamily: 'Nexa,sans-serif',
    cursor: 'pointer',
  },
  button: {
    display: 'flex',
    justifyContent: 'flex-end',
    textTransform: 'none',
  },
  button1: {
    backgroundColor: 'rgb(17, 137, 17)',
    color: 'rgb(255, 255, 255)',
    width: '150px',
    height: '40px',
    borderRadius: '6px',
    textTransform: 'none',
    marginTop: '4px',
    padding: '0px 50px',
    fontFamily: '"Nexa","Arial",sans-serif!important',
    fontWeight: 'bold',
    fontSize: '16px',
    lineHeight: '1.75',
    letterSpacing: '0.02857em',
    minWidth: '183px',
    minHeight: '50px',
    display: 'flex',
    justifyContent: 'flex-end',
    '&.loading': {
      color: 'primary', // Change this to the color you want
    },
  },
  spacing: {
    marginTop: '6px',
  },
  underline: {
    position: 'relative',
    display: 'inline-block',
  },
  underlineBefore: {
    position: 'absolute',
    content: '""',
    left: 0,
    right: 0,
    bottom: -1,
    height: '4px',
    backgroundColor: '#138911',
    borderRadius: '5px',
  },
  selectContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  select: {
    textAlign: 'center',
    backgroundColor: '#138911',
    color: 'white',
    '& .MuiSelect-icon': {
      color: 'white',
    },
  },
  icon: {
    width: '200px', // Adjust to 100
    height: '150px', // Adjust to 200
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center', // Ensures the icon stays centered
  },

  iconSvg: {
    width: '100%',
    height: '100%',
  },

  dialog: {
    backgroundColor: '#ededed',
    padding: '20px 20px 10px',
    color: '#265886',
    minWidth: '400px',
  },
  dialogFont: {
    fontFamily: '"Nexa","Arial",sans-serif!important',
    fontSize: '14px',
    fontWeight: '500',
  },
  closeIcon: {
    position: 'absolute',
    top: '10px',
    right: '10px',
    cursor: 'pointer',
    color: '#999',
  },
  noWait: {
    fontFamily: '"Nexa","Arial",sans-serif!important',
    fontSize: '17px',
    fontWeight: '500',
    color: '#265886',
  },
});

const QuoteGeneratorForm = (theme) => {

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPromoCode(null));
    dispatch(setCodeApplied(false));
    dispatch(setPromo(null));
  }, [dispatch])

  const format = 'HH:mm';

  // const navigate = useNavigate();

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState('');

  // const apiBaseUrl = process.env.REACT_APP_API_BASE_URL_B2C_PROXY;

  const apiBaseUrlAPI1 = process.env.REACT_APP_API_BASE_URL;

  const baseURL = process.env.REACT_APP_BASE_URL;

  // PICKUP STATES
  const [pickupAnchorEl, setPickupAnchorEl] = useState(null);
  // const [selectedDestination, setSelectedDestination] = useState(null);
  const [isPickupOpen, setIsPickupOpen] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [destinationOptions, setDestinationOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isDatePickerOpen, setDatePickerOpen] = useState(false);
  const [isDatePickerOpen1, setDatePickerOpen1] = useState(false);
  const selectedDestination = useSelector((state) => state.selectedDestination.selectedDestination);
  const promoCode = useSelector(state => state.promoCode?.promoCode ?? '');
  const promoCodeInputDisplay = useSelector(state => state.systemSettings?.promoCodeInputDisplay ?? false);

  const handlePickupClick = (event) => {
    setIsPickupOpen(true);
    setPickupAnchorEl(event.currentTarget);
  };

  const handleSearchClose = () => {
    setPickupAnchorEl(null);
    setIsPickupOpen(false);
  };

  const handlePickupSelect = (destination) => {
    dispatch(setSelectedDestination(destination));
    updateDropOffOptions(destination.id);
    handleSearchClose();
  };

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
   
  };

  useEffect(() => {
   const fetchData= async() => {
    const headers = {
      'Content-Type': 'application/json'
    };
    const jsonBody = {
      "company_id": 1,
      "filter": searchText,
      "from": "",
      "defaults": true,
      "direction": "from",
      "from-destination-id": "",
      "to-destination-id": ""
    }

    fetch(`${apiBaseUrlAPI1}/destination/searchDestinations`, {
      method: 'POST',
      headers,
      body: JSON.stringify(jsonBody)
    })
      .then((response) => response.json())
      .then((data) => {
        // Map the data to the required format
        const mappedOptions = data.map((item) => ({
          label: item.name,
          subtitle: item.country,
          value: item.name,
          type: item.type,
          id: item.id,
        }));

        // Define the list of specified airports
        const specifiedAirports = ['Geneva Airport (GVA)', 'Innsbruck Airport (INN)', 'Munich Airport (MUC)'];

        // // Filter specified airports from the mappedOptions
        // const airports = specifiedAirports.map((airportCode) => {
        //   return mappedOptions.find((option) => option.value === airportCode);
        // });

        // Sort the remaining destinations alphabetically
        const remainingOptions = mappedOptions.filter((option) => !specifiedAirports.includes(option.value));
        remainingOptions.sort((a, b) => {
          const labelA = a.label.toLowerCase();
          const labelB = b.label.toLowerCase();

          if (labelA.startsWith('a') && !labelB.startsWith('a')) {
            return -1; // 'A' items come first
          } else if (!labelA.startsWith('a') && labelB.startsWith('a')) {
            return 1; // 'A' items come later
          }

          return labelA.localeCompare(labelB); // Sort the rest alphabetically
        });

        // // Set the default drop-off location
        // const defaultDropOff = {
        //   label: 'La Tania',
        //   value: 'LTA', // Replace with the actual IATA code for La Tania
        // };

        // Combine specified airports, default drop-off, and sorted destinations
        // const allOptions = [...airports, ...remainingOptions];

        // Set the fetched data and the selected destination
        setDestinationOptions(mappedOptions);
        SetDropOffOptions(mappedOptions);
        // // Set the selected destination to La Tania
        // SetSelectedDropOff(defaultDropOff);

        setIsLoading(false); // Set loading state to false after data is fetched
      })
      .catch((error) => {
        setIsLoading(false); // Set loading state to false if there's an error
        
      });
   }
   fetchData();

  }, [apiBaseUrlAPI1,searchText]);

  const handleClearSearch = () => {
    setSearchText('');
  };

  useEffect(() => {
    const headers = {
      'Content-Type': 'application/json'
    };
    const jsonBody = {
      "company_id": 1,
      "filter": "",
      "from": "",
      "defaults": true,
      "direction": "from",
      "from-destination-id": "",
      "to-destination-id": ""
    }

    fetch(`${apiBaseUrlAPI1}/destination/searchDestinations`, {
      method: 'POST',
      headers,
      body: JSON.stringify(jsonBody)
    })
      .then((response) => response.json())
      .then((data) => {
        // Map the data to the required format
        const mappedOptions = data.map((item) => ({
          label: item.name,
          subtitle: item.country,
          value: item.name,
          type: item.type,
          id: item.id,
        }));

        // Define the list of specified airports
        const specifiedAirports = ['Geneva Airport (GVA)', 'Innsbruck Airport (INN)', 'Munich Airport (MUC)'];

        // Filter specified airports from the mappedOptions
        const airports = specifiedAirports.map((airportCode) => {
          return mappedOptions.find((option) => option.value === airportCode);
        });

        // Sort the remaining destinations alphabetically
        const remainingOptions = mappedOptions.filter((option) => !specifiedAirports.includes(option.value));
        remainingOptions.sort((a, b) => {
          const labelA = a.label.toLowerCase();
          const labelB = b.label.toLowerCase();

          if (labelA.startsWith('a') && !labelB.startsWith('a')) {
            return -1; // 'A' items come first
          } else if (!labelA.startsWith('a') && labelB.startsWith('a')) {
            return 1; // 'A' items come later
          }

          return labelA.localeCompare(labelB); // Sort the rest alphabetically
        });

        // // Set the default drop-off location
        // const defaultDropOff = {
        //   label: 'La Tania',
        //   value: 'LTA', // Replace with the actual IATA code for La Tania
        // };

        // Combine specified airports, default drop-off, and sorted destinations
        const allOptions = [...airports, ...remainingOptions];

        // Set the fetched data and the selected destination
        setDestinationOptions(allOptions);
        SetDropOffOptions(allOptions);
        // // Set the selected destination to La Tania
        // SetSelectedDropOff(defaultDropOff);

        setIsLoading(false); // Set loading state to false after data is fetched
      })
      .catch((error) => {
        setIsLoading(false); // Set loading state to false if there's an error
        
      });
  }, [apiBaseUrlAPI1]);







  // // Temp Data
  // useEffect(() => {
  //   // Map the data to the required format
  //   const mappedOptions = destinationsData.data.map((item) => ({
  //     label: item.destination,
  //     subtitle: item.country,
  //     value: item.IATA_code,
  //     type: item.destination_type_code,
  //     id: item.id,
  //   }));
  //   setDestinationOptions(mappedOptions);
  //   setIsLoading(false); // Set loading state to false after data is fetched
  // }, []);


  const filteredDestinations = destinationOptions.filter((destination) =>
    destination.label.toLowerCase().includes(searchText.toLowerCase())
  );

  // DROP OFF STATES
  const [dropOffAnchorEl, setDropOffAnchorEl] = useState(null);
  const selectedDropOff = useSelector((state) => state.selectedDropOff.selectedDropOff);

  const [isDropOffOpen, setIsDropOffOpen] = useState(false);
  const [searchDropOffText, SetSearchDropOffText] = useState('');
  const [dropOffOptions, SetDropOffOptions] = useState([]);


  // Define a function to fetch and update the Drop Off options
  const updateDropOffOptions = (destinationId) => {

    const headers = {
      'Content-Type': 'application/json'
    };

    const formData = {
      "company_id": "",
      "filter": "",
      "from": `${destinationId}`,
      "defaults": true,
      "direction": "to",
      "from-destination-id": "",
      "to-destination-id": ""
    }
    

    fetch(`${apiBaseUrlAPI1}/destination/SearchDestinations`, {
      method: 'POST',
      body: JSON.stringify(formData),
      headers
    })
      .then((response) => response.json())
      .then((data) => {
        // Map the data to the required format
        const mappedOptions = data.map((item) => ({
          label: item.destination,
          subtitle: item.country,
          value: item.IATA_code,
          type: item.type,
          id: item.id,
        }));



        setSelectedDropOff(null)
        SetDropOffOptions(mappedOptions);
        setIsLoading(false);
      })
      .catch((error) => {
        // console.log('Error fetching Drop Off options:', error);
      });
  };

  const handleDropOffClick = (event) => {
    setIsDropOffOpen(true);
    setDropOffAnchorEl(event.currentTarget);
  };

  const handleDropOffSearchClose = () => {
    setDropOffAnchorEl(null);
    setIsDropOffOpen(false);
  };

  const handleDropOffSelect = (dropOff) => {
    dispatch(setSelectedDropOff(dropOff));
    handleDropOffSearchClose();
  };

  const handleDropOffSearchChange = (event) => {
    SetSearchDropOffText(event.target.value);
  };

  const handleClearDropOffSearch = () => {
    SetSearchDropOffText('');
  };



  // // Temp Data
  // useEffect(() => {
  //   // Map the data to the required format
  //   const mappedOptions = destinationsData.data.map((item) => ({
  //     label: item.destination,
  //     subtitle: item.country,
  //     value: item.IATA_code,
  //     type: item.destination_type_code,
  //     id: item.id,
  //   }));
  //   setDestinationOptions(mappedOptions);
  //   setIsLoading(false); // Set loading state to false after data is fetched
  // }, []);


  const filteredDropOffDestinations = dropOffOptions.filter((destination) =>
    destination.label.toLowerCase().includes(searchDropOffText.toLowerCase())
  );

  // const navigate = useNavigate();

  const [selectedOption, setSelectedOption] = React.useState({
    label: 'Journey Type',
    value: 'Return',
  });
  const [pickupValue, setPickupValue] = React.useState(null);
  const [pickupOptions, setPickupOptions] = React.useState([]);
  const [dropoffValue, setDropoffValue] = React.useState(null);
  const [dropoffOptions, setDropoffOptions] = React.useState([]);
  // const [loading, setLoading] = React.useState(true); // Loading state

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorElPassengers, setAnchorElPassengers] = React.useState(null); // Separate anchorEl for Passengers popover
  const [adultsCount, setAdultsCount] = React.useState(2);
  const [childrenCount, setChildrenCount] = React.useState(0);
  const [infantsCount, setInfantsCount] = React.useState(0);

  // Convert the dayjs object to a JavaScript Date object and  Set initial outbound date to +2 days
  const [outboundDate, setOutboundDate] = React.useState(dayjs().add(2, 'day').set('hour', 12).set('minute', 0).toDate());
  // Convert the dayjs object to a JavaScript Date object and Calculate initial return date as +7 days from outbound
  const [returnDate, setReturnDate] = React.useState(dayjs().add(7, 'day').set('hour', 12).set('minute', 0).toDate());
  const [showWarning, setShowWarning] = useState(false);
  const [showWarning1, setShowWarning1] = useState(false);

  // Set the default date and time
  const defaultDateAndTime = dayjs().set('hour', 12).set('minute', 0);


  const [outboundTime, setOutboundTime] = React.useState(defaultDateAndTime);
  const [returnTime, setReturnTime] = React.useState(defaultDateAndTime);

  const preventDefault = (event) => event.preventDefault();

  // useEffect(() => {
  //   const headers = {
  //     'Content-Type': 'application/json'

  //   };
  //   fetch('https://qa-transfers.ski-lifts.com/api/destination/getDestinations', {
  //     method: 'GET',
  //     headers
  //   })
  //     .then((response) => response.json())
  //     .then((data) => {
  //       // Map the data to the required format
  //       const mappedOptions = data.map((item) => ({
  //         label: item.destination,
  //         subtitle: item.country,
  //         value: item.IATA_code,
  //         type: item.destination_type_code,
  //         id: item.id,
  //       }));
  //       setPickupOptions(mappedOptions);
  //       // setLoading(false); // Set loading state to false after data is fetched
  //     })
  //     .catch((error) => {
  //       
  //       // setLoading(false); // Set loading state to false if there's an error
  //     });
  // }, []);





  // useEffect(() => {
  //   const headers = {
  //     'Content-Type': 'application/json'

  //   };
  //   fetch('https://qa-transfers.ski-lifts.com/api/destination/getDestinations', {
  //     method: 'GET',
  //     headers
  //   })
  //     .then((response) => response.json())
  //     .then((data) => {
  //       // Map the data to the required format
  //       const mappedOptions = data.map((item) => ({
  //         label: item.destination,
  //         subtitle: item.country,
  //         value: item.IATA_code,
  //         type: item.destination_type_code,
  //         id: item.id,
  //       }));
  //       setDropoffOptions(mappedOptions);
  //       // setLoading(false); // Set loading state to false after data is fetched
  //     })
  //     .catch((error) => {
  //       
  //       // setLoading(false); // Set loading state to false if there's an error
  //     });
  // }, []);
  const handleSave = () => {
    
    // Get the default time in the same format as the outbound time
    const defaultTime = dayjs().set('hour', 12).set('minute', 0).format('HH:mm');
    const formattedOutboundTime = dayjs(outboundTime).format('HH:mm');

    
    // Check if the outbound time is different from the default time
    const isDifferent = formattedOutboundTime !== defaultTime;

    setShowWarning(!isDifferent);
   
    // Additional save logic
    setDatePickerOpen(false)
  };
  const handleSave1 = () => {
    


    // Get the default time in the same format as the outbound time
    const defaultTime = dayjs().set('hour', 12).set('minute', 0).format('HH:mm');
    const formattedReturnTime = dayjs(returnTime).format('HH:mm');
   

    // Check if the outbound time is different from the default time
    const isDifferent = formattedReturnTime !== defaultTime;

    setShowWarning1(!isDifferent);
    // Additional save logic
    setDatePickerOpen1(false)
  };

  // const renderCustomHeader = ({ date, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => (
  //   <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px' }}>
  //        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
  //           <IconButton disabled={prevMonthButtonDisabled} onClick={decreaseMonth}>
  //             <KeyboardArrowLeft />
  //           </IconButton>

  //           <Typography variant="h6" style={{ fontSize: '18px', fontWeight: 'bold', margin: '0 5px' }}>
  //             {dayjs(date).format('MMMM YYYY')}
  //           </Typography>

  //           <IconButton disabled={nextMonthButtonDisabled} onClick={increaseMonth}>
  //             <KeyboardArrowRight />
  //           </IconButton>
  //         </div>
  //       <div>
  //         <button
  //             style={{
  //               marginLeft: '10px',
  //               backgroundColor: '#4CAF50', // Green color
  //               color: 'white',
  //               border: 'none',
  //               padding: '10px 20px',
  //               textAlign: 'center',
  //               textDecoration: 'none',
  //               display: 'inline-block',
  //               fontSize: '13px',
  //               borderRadius: '5px',
  //               cursor: 'pointer',
  //             }}
  //           onClick={handleSave}
  //       >
  //         Save
  //     </button>

  //       </div>
  //   </div>
  // );

  // const renderCustomHeader1 = ({ date, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => (
  //   <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px' }}>
  //        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
  //           <IconButton disabled={prevMonthButtonDisabled} onClick={decreaseMonth}>
  //             <KeyboardArrowLeft />
  //           </IconButton>

  //           <Typography variant="h6" style={{ fontSize: '18px', fontWeight: 'bold', margin: '0 5px' }}>
  //             {dayjs(date).format('MMMM YYYY')}
  //           </Typography>

  //           <IconButton disabled={nextMonthButtonDisabled} onClick={increaseMonth}>
  //             <KeyboardArrowRight />
  //           </IconButton>
  //         </div>
  //       <div>
  //         <button
  //             style={{
  //               marginLeft: '10px',
  //               backgroundColor: '#4CAF50', // Green color
  //               color: 'white',
  //               border: 'none',
  //               padding: '10px 20px',
  //               textAlign: 'center',
  //               textDecoration: 'none',
  //               display: 'inline-block',
  //               fontSize: '13px',
  //               borderRadius: '5px',
  //               cursor: 'pointer',
  //             }}
  //           onClick={handleSave1}
  //       >
  //         Save
  //     </button>

  //       </div>
  //   </div>
  // );

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClosePassengers = () => {
    setAnchorElPassengers(null);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClickPassengers = (event) => {
    setAnchorElPassengers(event.currentTarget);
  };

  const handleMenuItemClick = (option) => {
    setSelectedOption(option);
    handleClose();
  };

  // const handlePickupChange = (event, value) => {
  //   setPickupValue(value);
 
  //   setDropoffValue(null);
  //   // setDropoffOptions([]);
  //   // if (value) {
  //   //   fetchDropoffOptions(value.value);
  //   // }
  // };
  // const debouncedHandlePickupChange = debounce(handlePickupChange, 300); // Adjust the debounce delay as needed



  // const handleDropoffChange = (event, value) => {
  //   setDropoffValue(value);
  
  // };

  // const handleDropoffInputChange = (event, newInputValue) => {
  //   if (newInputValue) {
  //     // debouncedFetchDropoffOptions(newInputValue);
  //   } else {
  //     setDropoffOptions([]);
  //   }
  // };



  // const fetchDropoffOptions = (pickupValue) => {

  //   const formData = new FormData();
  //   formData.append('filter', pickupValue);
  //   formData.append('company_id', 1); // Update with the desired company_id value

  //   const headers = {
  //     'Content-Type': 'application/json'

  //   };
  //   fetch('https://qa-transfers.ski-lifts.com/api/destination/getDestinations', {
  //     method: 'GET',
  //     headers
  //   })
  //     .then((response) => response.json())
  //     .then((data) => {
  //       // Map the data to the required format
  //       const mappedOptions = data.map((item) => ({
  //         label: item.destination,
  //         subtitle: item.country,
  //         value: item.IATA_code,
  //         type: item.destination_type_code,
  //         id: item.id,
  //       }));
  //       setDropoffOptions(mappedOptions);
  //     })
  //     .catch((error) => {
  

  //     });
  // };

  // Tempeorary
  // const fetchDropoffOptions = () => {
  //   try {
  //     const dropoffData = require('../../dummyDataResponses/destinations.json'); // Import the JSON data

  //     // Map the data to the required format
  //     const mappedOptions = dropoffData.data.map((item) => ({
  //       label: item.destination,
  //       subtitle: item.country,
  //       value: item.IATA_code,
  //       type: item.destination_type_code,
  //       id: item.id,
  //     }));

  //     setDropoffOptions(mappedOptions);
  //   } catch (error) {
  
  //   }
  // };

  // const debouncedFetchDropoffOptions = debounce(fetchDropoffOptions, 300); // Adjust the debounce delay as needed




  const formattedValueOutbound =
    outboundDate
      ? `${dayjs(outboundDate).format('MMMM D, YYYY')} ${dayjs(outboundTime).format('HH:mm')}`
      : '';

  const formattedValueReturn =
    returnDate
      ? `${dayjs(returnDate).format('MMMM D, YYYY')} ${dayjs(returnTime).format('HH:mm')}`
      : '';

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const getIcon = (type) => {
    switch (type) {
      case 'AIR':
        return <FlightIcon style={{ color: '#9a9a9a', marginRight: '8px' }} />;
      case 'RES':
        return <BusinessIcon style={{ color: '#9a9a9a', marginRight: '8px' }} />;
      case 'TRBU':
        return <TrainIcon style={{ color: '#9a9a9a', marginRight: '8px' }} />;
      case 'GOLF':
        return <GolfCourseIcon style={{ color: '#9a9a9a', marginRight: '8px' }} />;
      case 'BUS':
        return <DirectionsBusIcon style={{ color: '#9a9a9a', marginRight: '8px' }} />;
      case 'FERR':
        return <DirectionsBoatIcon style={{ color: '#9a9a9a', marginRight: '8px' }} />;
      default:
        return null;
    }
  };

  const getIconColor = (option) => {
    return selectedOption.value === option ? '#242529' : '#9a9a9a';
  };

  // const loadingAdornment = useMemo(() => {
  //   return loading ? <CircularProgress color="inherit" size={20} /> : null;
  // }, [loading]);

  const handleSwap = () => {
    const tempPickup = pickupValue;
    const tempDropoff = dropoffValue;
    setPickupValue(tempDropoff);
    setDropoffValue(tempPickup);
    setPickupOptions(dropoffOptions);
    setDropoffOptions(pickupOptions);
  };

  // const isOptionEqualToValue = (option, value) => option.value === value.value;

  const handleDecreaseAdults = () => {
    setAdultsCount((prevCount) => Math.max(prevCount - 1, 1));
  };

  const handleIncreaseAdults = () => {
    setAdultsCount((prevCount) => prevCount + 1);
  };

  const handleDecreaseChildren = () => {
    setChildrenCount((prevCount) => Math.max(prevCount - 1, 0));
  };

  const handleIncreaseChildren = () => {
    setChildrenCount((prevCount) => prevCount + 1);
  };

  const handleDecreaseInfants = () => {
    setInfantsCount((prevCount) => Math.max(prevCount - 1, 0));
  };

  const handleIncreaseInfants = () => {
    setInfantsCount((prevCount) => prevCount + 1);
  };

  // Outbound Date
  const handleOutboundDateTimeChange = (dateTime) => {

    // const formattedTime = format(dateTime, 'HH:mm');


    setOutboundDate(dateTime);





    // Recalculate return date based on new outbound date
    const newReturnDate = dayjs(dateTime).add(7, 'day').toDate();
    setReturnDate(newReturnDate);



  };

  const handleOutboundTime = (newTime) => {





    setOutboundTime(newTime);
  };

  const handleReturnTime = (newTime) => {





    setReturnTime(newTime);
  };
  // Return Date/ Inbound Date
  const handleInboundDateTimeChange = (dateTime) => {
    // const formattedTime = format(dateTime, 'HH:mm');

    setReturnDate(dateTime);
    // setReturnTime(formattedTime);
    // const defaultTime='12:00'

    // // Format the selected time to match the format of your default time
    // const selectedTime = dateTime ?  format(dateTime, 'HH:mm') : '';
   
 
    // const isDifferent = selectedTime !== defaultTime;
    // setShowWarning1(!isDifferent);
  


  };

  useEffect(() => {
    if (loading) {
      setLoadingText('Getting Quote');

      return () => {
        // Cleanup logic, if any
      };
    }
  }, [loading]);


  const handleGetQuote = () => {

    setLoading(true);



    // const oldheaders = {
    //   'Content-Type': 'application/json',
    //   'Authorization': 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJpYXQiOjE2OTUwMzkzOTksImV4cCI6MTg1MjcxOTM5OSwicm9sZXMiOlsiUk9MRV9VU0VSIl0sInVzZXJuYW1lIjoiYXBpLXNraWxpZnRzLXVzZXIifQ.RfqsTSrjPXQD6MP6EW0sPZm3lK6XgeywiYCKatj2p_bFh7Tg891JfDy5LwjObWOg2phIOgN8MWAaPqCaSdxW7EBhA9RSQJFC2faXNx3JkmZWG6zkyp2Vp_i0m5I_1VTpwlYwFZhBt60wtlZXFQAT4n4XZE0hsAZBOvKMGoNFLAipc9uIMdREPu_4k3QhStDNDgOIhYrbMxCCGGXLQ_6CuK9BBjw9hEuaRoe9mZ2Cf6zjQRlPIWw0Rc1I_OYJjA3IQBcxB4y6ML2RElXpIRdJi7LU8J4kuYIXc1LDR325kjVXRrodlVLN34sbPROyvxkPoe5LjGveWckdE_oOrzqzmA',
    //   'Accept-Version': '2',

    // };

    // // Gather search details for G4 and GTM
    // const searchDetails = {
    //   'DLV - transferName1': selectedDestination.label,
    //   'DLV - transferName2': selectedDropOff.label,
    //   'DLV - TY - Adults': adultsCount,
    //   'DLV - TY - Children': childrenCount + infantsCount,
    //   'DLV - TY - Date': outboundDate,
    // };

    // Push the search event to the data layer
    // pushSearchEvent(searchDetails);
    const headers = {
      'Content-Type': 'application/json'
    };

    const formattedOutboundDate = dayjs(outboundDate).format('YYYY-MM-DD');
    const formattedOutboundTime = dayjs(outboundTime).format('HH:mm');

    const formattedReturnDate = dayjs(returnDate).format('YYYY-MM-DD');
    const formattedReturnTime = dayjs(returnTime).format('HH:mm');




    // const newQuoteData = `{
    //   "journeyTypeSelector": {
    //     "value": "return",
    //     "label": "Return",
    //     "icon": {
    //       "type": {
    //         "type": {},
    //         "compare": null
    //       },
    //       "key": null,
    //       "ref": null,
    //       "props": {},
    //       "_owner": null
    //     }
    //   },
    //   "destinationFrom": {
    //     "value": "${selectedDestination.id}",
    //     "label": "${selectedDestination.label}",
    //     "name": "${selectedDestination.label}",
    //     "country": "${selectedDestination.subtitle}",
    //     "type": "${selectedDestination.type}"
    //   },
    //   "destinationTo": {
    //     "value": "${selectedDropOff.id}",
    //     "label": "${selectedDropOff.label}",
    //     "name": "${selectedDropOff.label}",
    //     "country": "${selectedDropOff.subtitle}",
    //     "type": "${selectedDropOff.type}"
    //   },
    //   "passengerSelector": {
    //     "adults": ${adultsCount},
    //     "children": ${childrenCount},
    //     "infants": ${infantsCount}
    //   },
    //   "pickUpDate": "${formattedOutboundDate}",
    //   "pickUpTime": "${outboundTime}",
    //   "dropOffDate": "${formattedReturnDate}",
    //   "dropOffTime": "${returnTime}",
    //   "companyId": ""
    // }`

    let transfers = [];

// If journey type is "Return", add both transfers
if (selectedOption.value === 'Return') {
  transfers = [
    {
      "id": 0,
      "fromDestination": {
        "id": selectedDestination.id
      },
      "toDestination": {
        "id": selectedDropOff.id
      },
      "date": formattedOutboundDate,
      "time": formattedOutboundTime,
      "adults": adultsCount,
      "numberOfChildren": childrenCount + infantsCount
    },
    {
      "id": 0,
      "fromDestination": {
        "id": selectedDropOff.id
      },
      "toDestination": {
        "id": selectedDestination.id
      },
      "date": formattedReturnDate,
      "time": formattedReturnTime,
      "adults": adultsCount,
      "numberOfChildren": childrenCount + infantsCount
    }
  ];
} else if (selectedOption.value === 'One Way') {
  // If journey type is "One Way", add only the first transfer
  transfers = [
    {
      "id": 0,
      "fromDestination": {
        "id": selectedDestination.id
      },
      "toDestination": {
        "id": selectedDropOff.id
      },
      "date": formattedOutboundDate,
      "time": formattedOutboundTime,
      "adults": adultsCount,
      "numberOfChildren": childrenCount + infantsCount
    }
  ];
}

const quoteData1 = JSON.stringify({
  "basket": {
    "id": 0,
    "transfers": transfers,
    "promoCode": promoCode
  }
});

    //   const quoteData = `[
    //     {
    //       "from_destination": "${pickupValue.id}",
    //       "to_destination": "${dropoffValue.id}",
    //       "travel_date": "${formattedOutboundDate}",
    //       "pickup_time": "${outboundTime}",
    //       "adults": ${adultsCount},
    //       "children":${childrenCount},
    //       "infants":${infantsCount}
    //     },
    //     {
    //       "from_destination": "${dropoffValue.id}",
    //       "to_destination": "${pickupValue.id}",
    //       "travel_date": "${formattedReturnDate}",
    //       "pickup_time": "${returnTime}",
    //       "adults": ${adultsCount},
    //       "children":${childrenCount},
    //       "infants":${infantsCount}
    //     }
    // ]`


    fetch(`${apiBaseUrlAPI1}/basket/createBasket`, {
      method: 'POST',
      headers: headers,
      body: quoteData1,
    })
      .then((response) => response.json())
      .then((data) => {
      
        dispatch(setQuoteResponse(data));
        // Gather form values
        const formValues = {
          pickupValue: selectedDestination,
          dropoffValue: selectedDropOff,
          outboundDate: outboundDate,
          outboundTime: formattedOutboundTime,
          adultsCount: adultsCount, // or get it from your form
          childrenCount: childrenCount,
          infantsCount: infantsCount,
          returnDate: formattedReturnDate,
          returnTime: formattedReturnTime
        };

        // Dispatch the action to store the form values
        dispatch(setTravelDetails(formValues));
        const headers = {
          'Content-Type': 'application/json'
        };
        fetch(`${apiBaseUrlAPI1}/basket/getBasket?guid=${data.basket.guid}`, {
          method: 'GET',
          headers: headers,
        })
          .then((response) => response.json())
          .then((data) => {
          
            dispatch(setCreateBookingResponse(data))
            // Book Logic
            // Assuming data.basket.options is an array
            const options = data.basket.options;
            
            // Check if any option has book set to false
            const hasOptionWithBookFalse = options.some(option => option.book === true);
           

            // Dispatch the action if the condition is met
            if (hasOptionWithBookFalse) {

              dispatch(updateBookingPrice(0, 0, '', true, null));
            }
            else {
              dispatch(updateBookingPrice(0, 0, '', false, null));
            }
            

          });
        setLoading(false);
        // navigate('/quote');
        const redirectToThirdParty = () => {
          const thirdPartyUrl = `${baseURL}/quote/${data.basket.guid}`;

          // Append a version parameter to force stylesheet reload
          const styleSheets = document.styleSheets;
          for (let i = 0; i < styleSheets.length; i++) {
            const sheet = styleSheets[i];
            const href = sheet.href;

            // Check if the stylesheet has an href
            if (href) {
              // Append a version parameter to force reload
              sheet.ownerNode.href = href + (href.includes('?') ? '&' : '?') + 'v=' + Date.now();
            }
          }

          // Use window.location.href to redirect
          window.top.location.href = thirdPartyUrl;
        };


        redirectToThirdParty();



      })
      .catch((error) => {
        // console.log('Error fetching quote:', error);
        // console.log('Full error object:', error.response);
      });





    // Temp
    // setTimeout(() => {
    //   dispatch(setQuoteResponse(mockQuoteResponse.data));
    //     // Gather form values
    //     const formValues = {
    //       pickupValue: pickupValue,
    //       dropoffValue: dropoffValue,
    //       outboundDate: outboundDate,
    //       outboundTime: outboundTime,
    //       adultsCount: adultsCount, // or get it from your form
    //       returnDate: returnDate,
    //       returnTime: returnTime
    //     };
    //   dispatch(setTravelDetails(formValues));
    //   navigate('/quote');
    //   setLoading(false);
    // }, 1000); // 1 second delay
    ;
  };


  // Set the first pickup and dropoff options initially
  // useEffect(() => {
  //   if (pickupOptions.length > 0) {
  //     setPickupValue(pickupOptions[0]);
  //   }

  // }, [pickupOptions]);

  // const OutboundDateInput = forwardRef(({ value, onClick }, ref) => {
  //   const formattedValue =
  //     value && outboundTime
  //       ? `${dayjs(value).format('MMMM D, YYYY')} ${dayjs(outboundTime).format(
  //           'HH:mm'
  //         )}`
  //       : '';

  //   return (
  //     <TextField
  //       label="Outbound Date"
  //       variant="outlined"
  //       onClick={() => setDatePickerOpen(!isDatePickerOpen)}
  //       ref={ref}
  //       value={formattedValue}
  //       fullWidth
  //       InputProps={{
  //         startAdornment: (
  //           <ListItemIcon>
  //             <CalendarTodayIcon />
  //           </ListItemIcon>
  //         ),
  //       }}
  //     />
  //   );
  // });
  // const InboundDateInput = forwardRef(({ value, onClick }, ref) => {
  //   const formattedValue =
  //     value && returnTime
  //       ? `${dayjs(value).format('MMMM D, YYYY')} ${dayjs(returnTime).format(
  //           'HH:mm'
  //         )}`
  //       : '';

  //   return (
  //     <TextField
  //       label="Return Date"
  //       variant="outlined"
  //       onClick={() => setDatePickerOpen1(!isDatePickerOpen1)}
  //       ref={ref}
  //       value={formattedValue}
  //       fullWidth
  //       InputProps={{
  //         startAdornment: (
  //           <ListItemIcon>
  //             <CalendarTodayIcon />
  //           </ListItemIcon>
  //         ),
  //       }}
  //     />
  //   );
  // });

  return (
    <div>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={3}>
            <Button
              onClick={handleClick}
              aria-describedby={id}
              variant="contained"
              style={{
                backgroundColor: '#fff',
                color: '#242529',
                display: 'flex',
                alignItems: 'center',
                border: '1px solid #cccccc',
                width: '100%',
                height: '57px',
                borderRadius: '6px',
                textTransform: 'none',
                textAlign: 'left',
                fontFamily: '"Nexa", Arial, sans-serif',
              }}
            >
              <ListItemIcon
                style={{
                  fontSize: '40px',
                  color: 'rgb(154, 154, 154)',
                  display: 'inline-block',
                }}
              >
                {selectedOption.value === 'Return' ? (
                  <SwapHorizIcon style={{ fontSize: '30px' }} onClick={handleSwap} />
                ) : (
                  <ArrowRightAltIcon style={{ fontSize: '30px' }} onClick={handleSwap} />
                )}
              </ListItemIcon>
              <div style={{ width: '100%' }}>
                <Typography variant="body1">
                  <span
                    style={{
                      color: '#9a9a9a',
                      display: 'block',
                      fontSize: '0.75em',
                      marginTop: '4px',
                      fontWeight: 'normal',
                      lineHeight: '0.7',
                      fontFamily: '"Nexa", Arial, sans-serif',
                    }}
                  >
                    {selectedOption ? selectedOption.label : 'Open Dropdown'}
                  </span>
                  <span
                    style={{
                      fontFamily: '"Nexa", Arial, sans-serif',
                      fontWeight: 'bold',
                      fontSize: '1em',
                    }}
                  >
                    {selectedOption ? selectedOption.value : ''}
                  </span>
                </Typography>
              </div>
            </Button>
            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              
            >
              <Paper>
                <DialogTitle>Booking Type</DialogTitle>
                <DialogContent>
                  <MenuItem
                    selected={selectedOption.value === 'One Way'}
                    onClick={() =>
                      handleMenuItemClick({
                        label: 'Journey Type',
                        value: 'One Way',
                      })
                    }
                  >
                    <ListItemIcon>
                      <ArrowRightAltIcon
                        style={{ fontSize: '30px', color: getIconColor('One Way') }}
                      />
                    </ListItemIcon>
                    One Way
                  </MenuItem>
                  <MenuItem
                    selected={selectedOption.value === 'Return'}
                    onClick={() =>
                      handleMenuItemClick({
                        label: 'Journey Type',
                        value: 'Return',
                      })
                    }
                  >
                    <ListItemIcon>
                      <SwapHorizIcon
                        style={{ fontSize: '30px', color: getIconColor('Return') }}
                      />
                    </ListItemIcon>
                    Return
                  </MenuItem>
                </DialogContent>
              </Paper>
            </Popover>
          </Grid>

          {/* PICKUP  */}

          <Grid item xs={12} md={4}>
            <Button
              variant="contained"
              color="primary"
              onClick={handlePickupClick}
              fullWidth
              startIcon={<LocationOnIcon style={{ color: selectedDestination ? '#73C790' : '#9a9a9a', fontSize: '2.1em' }} />}
              style={{
                display: 'flex',
                alignItems: 'left',
                justifyContent: 'flex-start',
                height: '57px',
                borderRadius: '6px',
                border: selectedDestination ? '1px solid #73C790' : '1px solid #cccccc',
                backgroundColor: selectedDestination ? '#e3fbe3' : '#fff', // Conditional background color
                color: selectedDestination ? '#73C790' : '#242529', // Conditional text color
                fontFamily: '"Nexa", Arial, sans-serif',
              }}
            >
              {isLoading ? (
                <CircularProgress size={24} style={{ color: 'grey' }} />
              ) : (
                <div style={{ textAlign: 'left', alignItems: 'flex-start' }}>
                  <Typography
                    variant="body1"
                    style={{
                      color: selectedDestination ? '#73C790' : '#9a9a9a',
                      fontSize: '0.99em',
                      fontFamily: '"Nexa","Arial",sans-serif!important',
                      fontWeight: '400',
                      textTransform: 'none',
                    }}
                  >
                    Pick Up
                  </Typography>
                  {selectedDestination ? (
                    <Typography
                      variant="body1"
                      style={{
                        color: selectedDestination ? '#73C790' : '#9a9a9a',
                        fontSize: '1.2em',
                        fontFamily: '"Nexa","Arial",sans-serif!important',
                        fontWeight: 'bold',
                        lineHeight: '1.2',
                        textTransform: 'none',
                      }}
                    >
                      {selectedDestination.label}
                    </Typography>
                  ) : (
                    <Typography
                      variant="body2"
                      style={{
                        color: 'black',
                        fontSize: '1.2em',
                        fontFamily: '"Nexa","Arial",sans-serif!important',
                        fontWeight: 'bold',
                        lineHeight: '1.2',
                        textTransform: 'none',
                      }}
                    >
                      Search...
                    </Typography>
                  )}
                </div>
              )}
            </Button>

            <Popover
              open={isPickupOpen}
              anchorEl={pickupAnchorEl}
              onClose={handleSearchClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
             
            >
              <Card>
                <Box width={430} height={400}>
                  <CardContent>
                    <Typography variant="h6" sx={{ fontFamily: '"Nexa", Arial, sans-serif', }} gutterBottom>
                      Pickup
                    </Typography>
                    <TextField
                      autoFocus={true}
                      label="Select Destination"
                      variant="outlined"
                      fullWidth
                      onChange={handleSearchChange}
                      value={searchText}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment position="end">
                            {searchText && (
                              <ClearIcon
                                style={{ cursor: 'pointer' }}
                                onClick={handleClearSearch}
                              />
                            )}
                          </InputAdornment>
                        ),
                      }}
                    />
                    {isLoading ? (
                      <Box display="flex" justifyContent="center" alignItems="center" height={200}>
                        <CircularProgress size={24} style={{ color: 'grey' }} />
                      </Box>
                    ) : (
                      // Add a container with a specific height and overflow-y
                      <Box
                        style={{ maxHeight: 300, overflowY: 'auto', marginTop: '12px' }}
                      >

                        {filteredDestinations.map((destination) => (
                          <li key={destination.id} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => handlePickupSelect(destination)}>
                            {getIcon(destination.type)}
                            <div>
                              <Typography variant="body1" style={{ fontWeight: 'bold' }}>
                                {destination.label}
                              </Typography>
                              <Typography variant="body2" style={{ color: '#9a9a9a' }}>
                                {destination.subtitle}
                              </Typography>
                            </div>
                          </li>
                        ))}
                      </Box>
                    )}
                  </CardContent>
                </Box>
              </Card>
            </Popover>
          </Grid>


          <Grid
            item
            xs={12}
            md={1}
            sx={{
              display: 'flex',
              justifyContent: {
                xs: 'flex-end',
                md: 'center',
              },
            }}
          >
            <div
              style={{
                width: '50px',
                height: '50px',
                borderRadius: '50%',
                backgroundColor: '#0099cc',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                fontFamily: '"Nexa", Arial, sans-serif',
              }}
              onClick={handleSwap}
            >
              <SwapHorizIcon
                style={{
                  color: 'white',
                  fontSize: '37px',
                  width: '1em',
                  height: '1em',
                  display: 'inline-block',
                  transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                  flexShrink: '0',
                  userSelect: 'none',
                  verticalAlign: 'middle',
                  fontFamily: '"Nexa", Arial, sans-serif',
                  fontWeight: '800',
                  transform: isMobile ? 'rotate(90deg)' : 'none',
                }}
              />
            </div>
          </Grid>

          {/* DROP OFF  */}

          <Grid item xs={12} md={4}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleDropOffClick}
              fullWidth
              startIcon={<LocationOnIcon style={{ color: selectedDropOff ? '#73C790' : '#9a9a9a', fontSize: '2.1em' }} />}
              style={{
                display: 'flex',
                alignItems: 'left',
                justifyContent: 'flex-start',
                height: '57px',
                border: selectedDropOff ? '1px solid #73C790' : '1px solid #cccccc',
                backgroundColor: selectedDropOff ? '#e3fbe3' : '#fff', // Conditional background color
                color: selectedDropOff ? '#73C790' : '#242529', // Conditional text color
                borderRadius: '6px',
                fontFamily: '"Nexa", Arial, sans-serif',
              }}
            >
              {isLoading ? ( // Show loading state if isLoading is true
                <CircularProgress size={24} style={{ color: 'grey' }} />
              ) : (
                <div style={{ textAlign: 'left', alignItems: 'flex-start' }}>
                  <Typography variant="body1" style={{ color: selectedDropOff ? '#73C790' : '#9a9a9a', fontSize: '0.99em', fontFamily: '"Nexa","Arial",sans-serif!important', fontWeight: '400', textTransform: 'none' }}>
                    Drop Off
                  </Typography>
                  {selectedDropOff !== null ? (
                    <Typography variant="body1" style={{ color: selectedDropOff ? '#73C790' : '#9a9a9a', fontSize: '1.2em', fontFamily: '"Nexa","Arial",sans-serif!important', fontWeight: 'bold', lineHeight: '1.2', textTransform: 'none' }}>
                      {selectedDropOff.label}
                    </Typography>
                  ) : (
                    <Typography variant="body2" style={{ color: 'black', fontSize: '1.2em', fontFamily: '"Nexa","Arial",sans-serif!important', fontWeight: 'bold', lineHeight: '1.2', textTransform: 'none' }}>
                      Search...
                    </Typography>
                  )}
                </div>
              )}

              {/* Add loading indicator or any other content on the right side if needed */}
            </Button>
            <Popover
              open={isDropOffOpen}
              anchorEl={dropOffAnchorEl}
              onClose={handleDropOffSearchClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
             
            >
              <Card>
                <Box width={430} height={400}>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      Drop Off
                    </Typography>
                    <TextField
                      autoFocus={true}
                      label="Select Destination"
                      variant="outlined"
                      fullWidth
                      onChange={handleDropOffSearchChange}
                      value={searchDropOffText}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment position="end">
                            {searchDropOffText && (
                              <ClearIcon
                                style={{ cursor: 'pointer' }}
                                onClick={handleClearDropOffSearch}
                              />
                            )}
                          </InputAdornment>
                        ),
                      }}
                    />
                    {isLoading ? (
                      <Box display="flex" justifyContent="center" alignItems="center" height={200}>
                        <CircularProgress size={24} style={{ color: 'grey' }} />
                      </Box>
                    ) : (
                      // Add a container with a specific height and overflow-y
                      <Box
                        style={{ maxHeight: 300, overflowY: 'auto' }}
                      >
                        {filteredDropOffDestinations.map((destination) => (
                          <li key={destination.id} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontFamily: '"Nexa", Arial, sans-serif', }} onClick={() => handleDropOffSelect(destination)}>
                            {getIcon(destination.type)}
                            <div>
                              <Typography variant="body1" style={{ fontWeight: 'bold' }}>
                                {destination.label}
                              </Typography>
                              <Typography variant="body2" style={{ color: '#9a9a9a' }}>
                                {destination.subtitle}
                              </Typography>
                            </div>
                          </li>
                        ))}
                      </Box>
                    )}
                  </CardContent>
                </Box>
              </Card>
            </Popover>
          </Grid>


          <Grid item xs={12} md={5}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <TextField
                label="Outbound Date"
                variant="outlined"
                onClick={() => setDatePickerOpen(!isDatePickerOpen)}
                value={formattedValueOutbound}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <ListItemIcon>
                      <CalendarTodayIcon />
                    </ListItemIcon>
                  ),
                }}
              />
              <Modal
                open={isDatePickerOpen}
                onClose={() => setDatePickerOpen(false)}
                style={{
                  display: 'flex',
                  alignItems: 'left',
                  justifyContent: 'left',
                  marginLeft: '145px',
                  marginTop: '-26px',
                  zIndex: 1050
                }}
                // Set the transform origin to position the modal above the text field
               
              >
                <div style={{ position: 'relative' }}>
                  <DatePicker
                    selected={outboundDate}
                    onChange={handleOutboundDateTimeChange}
                    timeFormat="HH:mm"
                    timeInputLabel="Flight Time"
                    dateFormat="MMMM d, yyyy HH:mm"
                    customInput={<></>}
                    minDate={addDays(new Date(), 2)}
                    open={isDatePickerOpen}
                    shouldCloseOnSelect={false}

                  >

                    <TimePicker defaultValue={outboundTime} onChange={handleOutboundTime} getPopupContainer={trigger => trigger.parentElement}
                                styles={{
                                  popup: {
                                    root: { zIndex: 9999 },
                                  },
                                }} format={format} minuteStep={5}  />

                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
                      <button
                        style={{
                          backgroundColor: '#4CAF50',
                          color: 'white',
                          border: 'none',
                          padding: '10px 20px',
                          textAlign: 'center',
                          textDecoration: 'none',
                          fontSize: '13px',
                          borderRadius: '5px',
                          cursor: 'pointer',
                        }}
                        onClick={handleSave}
                      >
                        Save
                      </button>
                    </div>
                  </DatePicker>

                  {showWarning && (
                    <div style={{ position: 'absolute', top: '100%', left: 0, fontFamily: '"Nexa", Arial, sans-serif', marginTop: '10px', display: 'flex', alignItems: 'center', color: 'black', fontWeight: 'bold' }}>
                      <WarningIcon style={{ color: 'orange' }} />
                      Please check your journey times are correct before continuing
                    </div>
                  )}
                </div>
              </Modal>
            </LocalizationProvider>
          </Grid>

          {selectedOption.value !== 'One Way' && (
            <Grid item xs={12} md={5}>
              <TextField
                label="Return Date"
                variant="outlined"
                onClick={() => setDatePickerOpen1(!isDatePickerOpen1)}
                // ref={ref}
                value={formattedValueReturn}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <ListItemIcon>
                      <CalendarTodayIcon />
                    </ListItemIcon>
                  ),
                }}
              />
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Modal style={{
                  display: 'flex',
                  alignItems: 'left',
                  justifyContent: 'center',
                  marginLeft: '-150px',
                  marginTop: '-25px',
                  zIndex: 1050
                }}
                  // Set the transform origin to position the modal above the text field
                 
                  open={isDatePickerOpen1} onClose={() => setDatePickerOpen1(false)}>
                  <div style={{ position: 'fixed' }}>
                    <DatePicker
                      selected={returnDate}
                      onChange={handleInboundDateTimeChange}
                      timeFormat="HH:mm"
                      timeInputLabel="Flight Time"
                      dateFormat="MMMM d, yyyy HH:mm"
                      customInput={<></>}
                      minDate={outboundDate}
                      open={isDatePickerOpen1}
                      shouldCloseOnSelect={false}
                    >

                      <TimePicker defaultValue={returnTime} onChange={handleReturnTime} getPopupContainer={trigger => trigger.parentElement}
                        popupStyle={{ position: 'absolute', top: '36px' }} format={format} minuteStep={5} />

                      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
                        <button
                          style={{
                            backgroundColor: '#4CAF50',
                            color: 'white',
                            border: 'none',
                            padding: '10px 20px',
                            textAlign: 'center',
                            textDecoration: 'none',
                            fontSize: '13px',
                            borderRadius: '5px',
                            cursor: 'pointer',
                            fontFamily: '"Nexa", Arial, sans-serif',
                          }}
                          onClick={handleSave1}
                        >
                          Save
                        </button>
                      </div>
                    </DatePicker>

                    {showWarning1 && (
                      <div style={{ position: isMobile ? 'relative' : 'absolute', top: '100%', left: 0, fontFamily: '"Nexa", Arial, sans-serif', marginTop: '10px', display: 'flex', alignItems: 'center', color: 'black', fontWeight: 'bold' }}>
                        <WarningIcon style={{ color: 'orange' }} />
                        Please check your journey times are correct before continuing
                      </div>
                    )}

                  </div>
                </Modal>
              </LocalizationProvider>
            </Grid>

          )}



          {/* Passengers Button */}
          <Grid item xs={12} md={2}>
            <Button
              onClick={handleClickPassengers}
              aria-describedby={id}
              variant="contained"
              style={{
                backgroundColor: '#fff',
                color: '#242529',
                display: 'flex',
                alignItems: 'center',
                border: '1px solid #cccccc',
                width: '100%',
                height: '57px',
                borderRadius: '6px',
                textTransform: 'none',
                textAlign: 'left',
                fontFamily: '"Nexa", Arial, sans-serif',
              }}
            >
              <ListItemIcon
                style={{
                  fontSize: '40px',
                  color: 'rgb(154, 154, 154)',
                  display: 'inline-block',
                  fontFamily: '"Nexa", Arial, sans-serif',
                }}
              >
                <BoyIcon />
              </ListItemIcon>
              <div style={{ width: '100%' }}>
                <Typography variant="body1">
                  <span
                    style={{
                      color: '#9a9a9a',
                      display: 'block',
                      fontSize: '0.75em',
                      fontWeight: 'normal',
                      lineHeight: '0.7',
                      fontFamily: '"Nexa", Arial, sans-serif',
                    }}
                  >
                    Passengers
                  </span>
                  <span
                    style={{
                      fontFamily: '"Nexa", Arial, sans-serif',
                      fontWeight: 'bold',
                      fontSize: '1em',
                    }}
                  >
                    {adultsCount + childrenCount}{' '}
                    {infantsCount > 0 && `(+ ${infantsCount} infant${infantsCount > 1 ? 's' : ''})`}
                  </span>
                </Typography>
              </div>
            </Button>
            <Popover
              id={id}
              open={Boolean(anchorElPassengers)}
              anchorEl={anchorElPassengers}
              onClose={handleClosePassengers}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
             
            >
              <Paper>
                <DialogTitle>Passengers</DialogTitle>
                <DialogContent>
                  <Typography variant="body1" style={{ fontWeight: 'bold' }}>
                    Adults
                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <IconButton
                      onClick={handleDecreaseAdults}
                      style={{ marginRight: '8px' }}
                      disabled={adultsCount === 1}
                    >
                      <RemoveIcon />
                    </IconButton>
                    <Typography variant="body1">{adultsCount}</Typography>
                    <IconButton onClick={handleIncreaseAdults} style={{ marginLeft: '8px' }}>
                      <AddIcon />
                    </IconButton>
                  </Box>
                  <Typography variant="body1" style={{ fontWeight: 'bold', marginTop: '16px' }}>
                    Children
                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <IconButton
                      onClick={handleDecreaseChildren}
                      style={{ marginRight: '8px' }}
                      disabled={childrenCount === 0}
                    >
                      <RemoveIcon />
                    </IconButton>
                    <Typography variant="body1">{childrenCount}</Typography>
                    <IconButton onClick={handleIncreaseChildren} style={{ marginLeft: '8px' }}>
                      <AddIcon />
                    </IconButton>
                  </Box>
                  <Typography variant="body1" style={{ fontWeight: 'bold', marginTop: '16px' }}>
                    Infants
                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <IconButton
                      onClick={handleDecreaseInfants}
                      style={{ marginRight: '8px' }}
                      disabled={infantsCount === 0}
                    >
                      <RemoveIcon />
                    </IconButton>
                    <Typography variant="body1">{infantsCount}</Typography>
                    <IconButton onClick={handleIncreaseInfants} style={{ marginLeft: '8px' }}>
                      <AddIcon />
                    </IconButton>
                  </Box>
                </DialogContent>
              </Paper>
            </Popover>
          </Grid>


          <Grid item xs={12} md={9} sx={{textAlign: 'left' }}>
            <Box
              sx={{
                typography: 'body2',
                '& > :not(style) + :not(style)': {

                },
                fontSize: '1.1428571428571428rem',
                fontWeight: '400',
                lineHeight: '1',
                fontFamily: '"Nexa","Arial",sans-serif!important',
                color: '#265885',
                textDecoration: 'none',
                display: 'block',
                marginBlockStart: '1em',
                marginBlockEnd: '1em',
                marginInlineStart: '0px',
                marginInlineEnd: '0px',

              }}
              onClick={preventDefault}
            >
              <Link href="#" style={{textDecoration: 'none', color: '#265885', fontFamily: '"Nexa", Arial, sans-serif' }} className="link">
                Can’t find what you are looking for? <span style={{ fontWeight: 'bold' }}>Get in touch</span>
              </Link>


            </Box>
          </Grid>
          <Grid item xs={12} md={3} sx={{ textAlign: 'center' }}>
            {loading ? (
              // Display loading state with text and circular progress
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <CircularProgress size={24} style={{ color: 'grey', marginRight: '8px' }} />
                <Typography variant="body1" style={{ fontWeight: 'bold', fontSize: '1.2rem', color: 'grey' }}>
                  {loadingText}
                </Typography>
              </div>
            ) : (
              <Button
                variant="contained"
                style={{
                  backgroundColor: 'rgb(17, 137, 17)',
                  color: 'rgb(255, 255, 255)',
                  width: '150px',
                  height: '40px',
                  borderRadius: '6px',
                  textTransform: 'none',
                  padding: '0px 50px',
                  fontFamily: '"Nexa","Arial",sans-serif!important',
                  fontWeight: 'bold',
                  fontSize: '1rem',
                  lineHeight: '1.75',
                  letterSpacing: '0.02857em',
                  minWidth: '100%',
                  minHeight: '50px'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#265885';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgb(17, 137, 17)';
                }}
                onClick={handleGetQuote}
                fullWidth
              >
                <SearchIcon />
                Search
              </Button>
            )}
          </Grid>

          {/*Promo code input*/}
          {promoCodeInputDisplay && (
            <Grid item xs={12} md={12}>
              <PromoCodeInput />
            </Grid>
          )}
        </Grid>
      </Box>
    </div>

  );
}


export default withStyles(styles, {withTheme: true})(QuoteGeneratorForm)
